import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setTitle('Benutzer')
        .setRoute('user_list')
        .setAdditionalRoutes([
            'user_detail',
        ]),

    MenuEntry.create()
        .setTitle('Aktive Tageslogins')
        .setRoute('user_login_token_list')
        .setAdditionalRoutes([
            'user_login_token_create',

        ]),
];
